import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './i18n';
import reportWebVitals from './reportWebVitals';
import './global.scss';

import 'react-phone-input-2/lib/style.css';
import 'react-datepicker/dist/react-datepicker.css';
import './presentation/styles/global.scss';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
